import React from "react";
import { Route, Switch } from "react-router-dom";

import ZoomLayout from "../layout/zoom";
import GeoGate from "../layout/GeoGate";
import NotFound from "../components/UI/NotFound";
import CheckYourEmail from "../components/UI/CheckYourEmail";

const ZoomRouter = ({ match }) => {
  const renderZoomRoute = (routeProps) => (
    <GeoGate eventId={routeProps.match.params.eventId}>
      <ZoomLayout {...routeProps} match={routeProps} />
    </GeoGate>
  );

  return (
    <Switch>
      <Route
        exact
        path={`${match.path}/:eventId`}
        render={renderZoomRoute}
      />
      <Route
        exact
        path={`${match.path}/:eventId/:confirmationId`}
        render={renderZoomRoute}
      />
      <Route component={NotFound} />
    </Switch>
  );
};

export default ZoomRouter;
